export const enviar = async (url, data) => {
  const body = { plataforma: 'WEB', empresa: 'AIGMEX', Data: data };
  const datos = await fetch(url, {
    method: 'post',
    body: JSON.stringify(body),
  });
  return datos.json();
};
